import { useMutation, useQueryClient } from "react-query";
import { updateKlaviyoProperties } from "@services/account/updateKlaviyoProperties";

export const useUpdateKlaviyoProperties = (account, setSuccess) => {
  const queryClient = useQueryClient();

  const updateKlaviyoFn = (properties) => updateKlaviyoProperties(properties);
  const queryToken = ["getKlaviyoInfo", account.klaviyoData.$email];

  const klaviyoUpdate = useMutation(updateKlaviyoFn, {
    onMutate: async updatedCustomer => {
      // The following is an optimistic update
      // https://react-query.tanstack.com/guides/optimistic-updates
      await queryClient.cancelQueries(queryToken);
      const previous = queryClient.getQueryData(queryToken);
      queryClient.setQueryData(queryToken, old => ({ ...old, ...updatedCustomer }));
      return { previous };
    },
    onSettled: (data, error, variables, context) => {
      if (data.body === 0 || error) {
        console.log("[klaviyo]: error updating properties");
        queryClient.setQueryData(queryToken, context.previous);
      };

      if (data.body === 1) {
        setSuccess(true);
      };
    }
  });

  return klaviyoUpdate;
}